import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { FaExclamationTriangle } from 'react-icons/fa';

const RestoreBackupModal = ({ show, onHide, onConfirm, backupName = '', loading = false }) => {

    const handleConfirm = async () => {
        try {
            await onConfirm();
            onHide();
        } catch (error) {
            console.error('Error in restore backup:', error);
        }
    };

    return (
        <Modal show={show} onHide={onHide} size="md" centered>
            {/* Header with alert icon */}
            <Modal.Header className='bg-gradient-to-r from-slate-700 to-slate-600 text-white px-6 py-4 flex items-center' style={{
                backgroundColor: '#6c757d',
                color: 'white',
                padding: '12px 20px',
                borderRadius: '8px 8px 0 0',
                marginBottom: '0',
                display: 'flex',
                alignItems: 'center',
                gap: '10px'
            }}>
                <span style={{ fontWeight: 'bold' }}>Alerta</span>
                <FaExclamationTriangle />
            </Modal.Header>

            <Modal.Body style={{ padding: '30px', textAlign: 'center' }}>
                {/* Alert message */}
                <div style={{ marginBottom: '25px', lineHeight: '1.6' }}>
                    <p style={{ margin: '0 0 10px 0', fontSize: '16px' }}>
                        Tem certeza que deseja restaurar o backup:<br />
                        <strong style={{ color: '#003B6B' }}>"{backupName}"</strong>?
                        <br /><br />
                        Os dados atuais serão movidos para o histórico.
                        <br /><br />
                        <strong>Confirmar operação?</strong>
                    </p>
                </div>

                {/* Action buttons */}
                <div style={{ display: 'flex', justifyContent: 'center', gap: '15px' }}>
                    <Button
                        variant="danger"
                        onClick={onHide}
                        disabled={loading}
                        style={{
                            backgroundColor: '#dc3545',
                            borderColor: '#dc3545',
                            padding: '10px 30px',
                            fontWeight: 'bold',
                            borderRadius: '8px',
                            minWidth: '100px'
                        }}
                    >
                        Cancelar
                    </Button>

                    <Button
                        variant="primary"
                        onClick={handleConfirm}
                        disabled={loading}
                        style={{
                            backgroundColor: '#003B6B',
                            borderColor: '#003B6B',
                            padding: '10px 30px',
                            fontWeight: 'bold',
                            borderRadius: '8px',
                            minWidth: '100px'
                        }}
                    >
                        {loading ? 'Processando...' : 'Confirmar'}
                    </Button>
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default RestoreBackupModal;
